import output from './output/store';
import migration from './migration/store';
import updation from './updation/store';
import log from './log/store';
import common from './common/store';

export default {
  namespaced: true,
  modules: { output, migration, updation, log, common },
};
